"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadNextElementsPageSaga = exports.loadNextElementsPageWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sagas_1 = require("../common/sagas");
var selectors_1 = require("../common/selectors");
var elementsSaga_1 = require("../elements/elementsSaga");
var slice_1 = require("../store/slice");
var loadNextElementsPageSelectors_1 = require("./loadNextElementsPageSelectors");
/**
 * @internal
 */
function loadNextElementsPageWorker() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest([
                    slice_1.actions.loadNextElementsPageRequest.match,
                    slice_1.actions.loadNextElementsPageCancelRequest.match,
                    slice_1.actions.loadInitialElementsPageRequest.match,
                ], loadNextElementsPageSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.loadNextElementsPageWorker = loadNextElementsPageWorker;
/**
 * @internal
 */
function loadNextElementsPageSaga(action) {
    var context, correlation, hasNextPage, loadOptions, elementsForm, loadOptionsWithExcludePrimaryLabel, result, error_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(sagas_1.getAttributeFilterContext)];
            case 1:
                context = _a.sent();
                if (slice_1.actions.loadNextElementsPageCancelRequest.match(action) ||
                    slice_1.actions.loadInitialElementsPageRequest.match(action)) {
                    // Saga was triggered by cancel request - do nothing, just jump to finally statement
                    return [2 /*return*/];
                }
                correlation = action.payload.correlation;
                return [4 /*yield*/, effects_1.select(loadNextElementsPageSelectors_1.selectHasNextPage)];
            case 2:
                hasNextPage = _a.sent();
                if (!hasNextPage) {
                    return [2 /*return*/];
                }
                _a.label = 3;
            case 3:
                _a.trys.push([3, 9, 11, 15]);
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadNextElementsPageStart({ correlation: correlation }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(loadNextElementsPageSelectors_1.selectLoadNextElementsPageOptions)];
            case 5:
                loadOptions = _a.sent();
                return [4 /*yield*/, effects_1.select(selectors_1.selectElementsForm)];
            case 6:
                elementsForm = _a.sent();
                loadOptionsWithExcludePrimaryLabel = tslib_1.__assign(tslib_1.__assign({}, loadOptions), { excludePrimaryLabel: !context.backend.capabilities.supportsElementUris && elementsForm === "values" });
                return [4 /*yield*/, effects_1.call(elementsSaga_1.elementsSaga, loadOptionsWithExcludePrimaryLabel)];
            case 7:
                result = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadNextElementsPageSuccess(tslib_1.__assign(tslib_1.__assign({}, result), { correlation: correlation })))];
            case 8:
                _a.sent();
                return [3 /*break*/, 15];
            case 9:
                error_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadNextElementsPageError({
                        error: error_1,
                        correlation: correlation,
                    }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 15];
            case 11: return [4 /*yield*/, effects_1.cancelled()];
            case 12:
                if (!_a.sent()) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadNextElementsPageCancel({ correlation: correlation }))];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [7 /*endfinally*/];
            case 15: return [2 /*return*/];
        }
    });
}
exports.loadNextElementsPageSaga = loadNextElementsPageSaga;
//# sourceMappingURL=loadNextElementsPageSaga.js.map